// @mui
// import { arSA, enUS, frFR, viVN, zhCN } from '@mui/material/locale';
import {fr, enUS} from 'date-fns/locale'

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'French',
    value: 'fr',
    systemValue: fr,
    dateFormat: 'dd MMM yyyy',
    placeholderInputDateFormat: 'jj/mm/aaaa',
    timeFormat: 'HH:mm:ss',
    icon: '/assets/icons/flags/ic_flag_fr.svg',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    dateFormat: 'MMM d, yyyy',
    placeholderInputDateFormat: 'MM/dd/yyyy',
    timeFormat: 'h:mm:ss a',
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
];

export const defaultLang = allLangs[0]; // English
